import { INQUIRY_ERROR, GET_INQUIRY } from "../constants/inquiryConstants";
import Axios from "axios";
import ax from "../components/auth/axios";
import { API_ROOT } from "../components/utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/x-www-form-urlencoded",
  },
};
export const requestInquiry = () => (dispatch) => {
  Axios.get(`${API_ROOT}/inqueries/`, config)
    .then((response) => dispatch({ type: GET_INQUIRY, payload: response.data }))
    .catch((error) => dispatch({ type: INQUIRY_ERROR, payload: error }));
};

export const updateInquiry = (id, formData) => (dispatch) => {
  ax.patch(`${API_ROOT}/inqueries/${id}`, formData, config)
    .then((response) => dispatch({ type: GET_INQUIRY, payload: response.data }))
    .catch((error) => dispatch({ type: INQUIRY_ERROR, payload: error }));
};
const config1 = {
  headers: {
    Authorization: token,
  },
};
export const deleteInquiry = (id) => (dispatch) => {
  ax.delete(`${API_ROOT}/inqueries/${id}`, config)
    .then((response) => console.log(response))
    .catch((error) => dispatch({ type: INQUIRY_ERROR, payload: error }));
};
